import { render, staticRenderFns } from "./TiposDiseniosData.vue?vue&type=template&id=9194b282&"
import script from "./TiposDiseniosData.vue?vue&type=script&lang=js&"
export * from "./TiposDiseniosData.vue?vue&type=script&lang=js&"
import style0 from "./TiposDiseniosData.vue?vue&type=style&index=0&id=9194b282&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports